import React from "react";

export default function ModalSucursal({
  abierto,
  onCerrar,
  sucursales,
  sucursalSeleccionada,
  onSeleccionar,
}) {
  if (!abierto) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.5)", zIndex: 1050 }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded-4">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">Seleccionar sucursal</h5>
            <button type="button" className="btn-close" onClick={onCerrar} />
          </div>

          <div className="modal-body p-0">
            {(sucursales || []).length === 0 ? (
              <p className="text-muted p-4 mb-0">No hay sucursales disponibles.</p>
            ) : (
              <div className="list-group list-group-flush">
                {(sucursales || []).map((sucursal) => {
                  const activa =
                    String(sucursal.id) === String(sucursalSeleccionada?.id);

                  return (
                    <button
                      key={sucursal.id}
                      type="button"
                      className={`list-group-item list-group-item-action ${
                        activa ? "active" : ""
                      }`}
                      onClick={() => onSeleccionar?.(sucursal.id)}
                    >
                      <div className="fw-semibold">{sucursal.nombre}</div>
                      {sucursal.direccion && (
                        <small className={activa ? "text-white-50" : "text-muted"}>
                          {sucursal.direccion}
                        </small>
                      )}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
